<template>
  <button class="btn btn-outline-gray btn-sm is-border-1" @click="exportBenhNhan">
    <i class="icon12-export-primary icon-left"></i>{{ $t('export') }}
    <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop
             no-enforce-focus>
      <div class="alert alert-warning">
        <b-spinner small variant="primary"></b-spinner>&nbsp;
        <span>{{ $t('exportNotice') }}</span>
        <b-progress :max="totalCount">
          <b-progress-bar :value="downloadedCount"
                          :label="`${((downloadedCount / totalCount) * 100).toFixed(0)}%`"></b-progress-bar>
        </b-progress>
      </div>
    </b-modal>
  </button>
</template>

<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';
import QUESTION_LIST from './constants/benh-nhan-call-question-list.json';

export default {
  props: ['filter', 'totalCount'],
  data() {
    return {
      exporting: false,
      downloadedCount: 0,
      questionList: QUESTION_LIST
    }
  },
  methods: {
    close(evt) {
      if (this.exporting) {
        evt.preventDefault();
      } else {
        this.exporting = false;
      }
      this.downloadedCount = 0;
    },
    exportBenhNhan: async function () {
      this.exporting = true;
      this.downloadedCount = 0;
      let workbook = new Excel.Workbook();
      let sheet = workbook.addWorksheet('Danh sách bệnh nhân');
      let cols = [
        {header: 'testCode', key: 'testCode', width: 20},
        {header: 'name', key: 'name', width: 15},
        {header: 'testReason', key: 'testReason', width: 15},
        {header: 'testDate', key: 'testDate', width: 15},
        {header: 'ctValue', key: 'ctValue', width: 15},
        {header: 'phone', key: 'phone', width: 15},
        {header: 'dob', key: 'dob', width: 15},
        {header: 'age', key: 'age', width: 15},
        {header: 'gender', key: 'gender', width: 15},
        {header: 'address', key: 'address', width: 15},
        {header: 'wardCode', key: 'wardCode', width: 15},
        {header: 'districtCode', key: 'districtCode', width: 15},
        {header: 'provinceCode', key: 'provinceCode', width: 15},
        {header: 'doctorUser', key: 'doctorUser', width: 15},
        {header: 'followUser', key: 'followUser', width: 15},
        {header: 'createTime', key: 'createTime', width: 15},
        {header: 'tier', key: 'tier', width: 15},
        {header: 'stopFollowTime', key: 'stopFollowTime', width: 15},
        {header: 'stopFollowReason', key: 'stopFollowReason', width: 15},
        {header: 'fault', key: 'fault', width: 15},
        {header: 'faultDetail', key: 'faultDetail', width: 15},
        {header: 'result', key: 'result', width: 15},
        {header: 'benhNen', key: 'benhNen', width: 15},
      ];
      let row = {
        testCode: 'Mã xét nghiệm',
        name: 'Họ tên bệnh nhân',
        testReason: 'Lý do xét nghiệm',
        testDate: 'Ngày xét nghiệm',
        getOutOfHospitalDate: 'Ngày xét nghiệm',
        ctValue: 'CT Value',
        phone: 'SĐT',
        dob: 'Năm sinh',
        gender: 'Giới tính',
        address: 'Địa chỉ',
        wardCode: 'Mã Xã/Phường',
        districtCode: 'Mã Quận/Huyện',
        provinceCode: 'Mã Tỉnh/TP',
        doctorUser: 'Bác sỹ phụ trách',
        followUser: 'TNV phụ trách',
        createTime: 'Tạo lúc',
        tier: 'Tầng NC',
        stopFollowTime: 'Ngày ngừng theo dõi',
        stopFollowReason: 'Lý do ngừng theo dõi',
        fault: 'Lỗi',
        faultDetail: 'Chi tiết lỗi',
        result: 'Kết quả sàng lọc',
        benhNen: 'Bệnh nền (nếu có)'
      };
      sheet.columns = cols;
      sheet.addRow(row);
      //Y section
      let ySection = workbook.addWorksheet('Các triệu chứng Y');
      ySection.columns = [
        {header: 'value', key: 'value', width: 15},
        {header: 'text', key: 'text', width: 20},
      ];
      for (let item of this.ySection) {
        ySection.addRow({value: item.value, text: item.text});
      }
      //YS section
      let ysSection = workbook.addWorksheet('Các triệu chứng YS');
      ysSection.columns = [
        {header: 'value', key: 'value', width: 15},
        {header: 'text', key: 'text', width: 20},
      ];
      for (let item of this.ysSection) {
        ysSection.addRow({value: item.value, text: item.text});
      }

      let response = null;
      let params = Object.assign({}, this.filter);
      params.page = 1;
      params.pageSize = 500;
      do {
        let result = await this.$service.get('/benh-nhan/', {
          params: params
        });
        params.page += 1;
        response = result.data;
        response.docs.forEach(item => {
          let row = {
            testCode: item.testCode ? item.testCode : '',
            name: item.name ? item.name : '',
            testReason: item.testReason ? item.testReason : '',
            testDate: item.testDate ? item.testDate : '',
            getOutOfHospitalDate: item.testDate ? item.testDate : '',
            ctValue: item.ctValue ? item.ctValue : '',
            phone: item.phone ? item.phone : '',
            dob: item.dob ? item.dob : '',
            age: item.age ? item.age : '',
            gender: item.gender === 'male' ? 'Nam' : item.gender === 'female' ? 'Nữ' : 'Không rõ',
            address: item.address ? item.address : '',
            wardCode: item.wardCode ? item.wardCode : '',
            districtCode: item.districtCode ? item.districtCode : '',
            provinceCode: item.provinceCode ? item.provinceCode : '',
            doctorUser: item.doctorUser ? `${item.doctorUser.name} (${item.doctorUser.email})` : '',
            followUser: item.followUser ? `${item.followUser.name} (${item.followUser.email})` : '',
            createTime: moment(item.createTime).format('DD/MM/YYYY HH:mm'),
            tier: item.tier ? item.tier : 'Chưa phân tầng',
            stopFollowTime: item.stopFollowTime ? moment(item.stopFollowTime).format('DD/MM/YYYY') : '',
            stopFollowReason: item.stopFollowReason ? item.stopFollowReason : '',
            fault: item.fault ? item.fault : '',
            faultDetail: item.faultDetail ? item.faultDetail : '',
            result: 'N',
            benhNen: ''
          };
          if (item.lastFormDetails && item.lastFormDetails.length && item.lastFormDetails[0].length) {
            let lastFormDetails = JSON.parse(item.lastFormDetails[0]);
            if (lastFormDetails && lastFormDetails.length) {
              let y = false;
              let ys = false;
              let benhNen = [];
              for (let detail of lastFormDetails) {
                if (this.ySection.find(s => s.value === detail)) {
                  y = true;
                } else if (this.ysSection.find(s => s.value === detail)) {
                  ys = true;
                }
                let bn = this.benhNenSection.find(s => s.value === detail);
                if (bn) {
                  benhNen.push(bn.text);
                }
              }
              if (ys) {
                row.result = 'YS'
              } else if (y) {
                row.result = 'Y'
              }
              if (benhNen.length) {
                row.benhNen = benhNen.join(', ')
              }
            }
          }
          sheet.addRow(row);
          this.downloadedCount += 1;
        });
      } while (this.exporting && response && response.hasNextPage);

      workbook.xlsx.writeBuffer({base64: true}).then(data => {
        this.exporting = false;
        this.downloadedCount = 0;
        saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
            'benh-nhan.xlsx');
      });
    },
  },
  computed: {
    ySection() {
      let result = [];
      for (let section of this.questionList) {
        if (["S3000", "S4000"].includes(section.section_id)) {
          if (section.question_list && section.question_list.length) {
            for (let item of section.question_list) {
              result.push({value: item.value, text: item.text})
            }
          }
        }
      }
      return result;
    },
    ysSection() {
      let result = [];
      for (let section of this.questionList) {
        if (["S1000", "S2000"].includes(section.section_id)) {
          if (section && section.question_list && section.question_list.length) {
            for (let item of section.question_list) {
              result.push({value: item.value, text: item.text})
            }
          }
        }
      }
      return result;
    },
    benhNenSection() {
      let result = [];
      let section = this.questionList.find(s => s.section_id === 'S5000');
      if (section && section.question_list && section.question_list.length) {
        for (let item of section.question_list) {
          result.push({value: item.value, text: item.text})
        }
      }
      return result
    }
  },
}
</script>